<template>
  <div class="service_manage" >
    <el-divider content-position="left">套餐类型管理列表</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpenMeal">新增套餐</el-button>
        <a href="/comb_product_type">
          <el-button type="warning" size="small">新增产品类型</el-button>
        </a>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <el-table :data="pageDataMeal" size="medium" style="width: 100%" height="470">
      <el-table-column label='id' width="100" fixed>
        <template slot-scope="scope">
          {{ scope.row.combo_id }}
        </template>
      </el-table-column>
      <el-table-column label='产品类别'>
        <template slot-scope="scope">
          {{ scope.row.type_name }}
        </template>
      </el-table-column>
      <el-table-column label='套餐名称'>
        <template slot-scope="scope">
          {{ scope.row.combo_name }}
        </template>
      </el-table-column>
      <el-table-column label='套餐内容'>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.combo_content" placement="top">
            <span class="count_style" style="display: inherit; cursor: pointer">{{ scope.row.combo_content }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label='套餐价格'>
        <template slot-scope="scope">
          {{ scope.row.combo_price }}
        </template>
      </el-table-column>
      <el-table-column label='套餐提成'>
        <template slot-scope="scope">
          {{ scope.row.combo_royalty }}
        </template>
      </el-table-column>
      <el-table-column label='是否含注册'>
        <template slot-scope="scope">
          {{ scope.row.combo_include_reg === 2 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEditMeal(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-popconfirm @onConfirm="handleDeleteMeal(scope.$index, scope.row.combo_id)" confirmButtonText='确定'
            cancelButtonText='取消' icon="el-icon-info" iconColor="red" title="这是一段内容确定删除吗？">
            <el-button size="mini" type="danger" slot="reference">
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!--    页码-->
    <el-pagination background class="tr mt-10" layout="total, prev, pager, next, jumper" :hide-on-single-page="false"
      :current-page="pageOptionMeal.currentPage" :page-sizes="[10, 20]" :page-size="pageOptionMeal.pageSize"
      :total="pageOptionMeal.total" @size-change="handleSizeChangeMeal" @current-change="handleCurrentChangeMeal">
    </el-pagination>
    <!--    添加-->
    <el-drawer title="添加" :visible.sync="AddDrawerMeal" :direction="direction" :before-close="handleClose" size="40%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">产品类型</el-col>
          <el-col :span="10">
            <el-select v-model="addDataMeal.type_id" placeholder="请选择" clearable filterable size="mini"
              style="width: 100%" @click.native="combloadCategory">
              <el-option v-for="item in combtype" :key="item.id" :label="item.type_name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">套餐名称</el-col>
          <el-col :span="10">
            <el-input placeholder="请输入套餐名称" :size="inputSize" v-model="addDataMeal.combo_name" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">套餐价格</el-col>
          <el-col :span="10">
            <el-input placeholder="请输入套餐价格" :size="inputSize" v-model="addDataMeal.combo_price" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">套餐提成</el-col>
          <el-col :span="10">
            <el-input placeholder="请输入套餐提成" :size="inputSize" v-model="addDataMeal.combo_royalty" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">是否含注册：</el-col>
          <el-col :span="10" class="m-label">
            <el-switch v-model="switchValueMeal" :width="40" @change="switchChangeMeal" active-text="">
            </el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">套餐内容</el-col>
          <el-col :span="10">
            <el-input type="textarea" :rows="4" placeholder="请输入套餐内容" :size="inputSize"
              v-model="addDataMeal.combo_content" clearable>
            </el-input>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAddMeal">添加</el-button>
        </div>
      </div>
    </el-drawer>
    <!--    编辑-->
    <el-drawer title="编辑" :visible.sync="saveDrawerMeal" :direction="direction" :before-close="handleSaveDrawerClose"
      size="40%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="6" class="m-label">产品类型</el-col>
          <el-col :span="10">
            <el-select v-model="saveDataMeal.type_id" placeholder="请选择" clearable filterable size="mini"
              style="width: 100%" @click.native="combloadCategory">
              <el-option v-for="item in combtype" :key="item.id" :label="item.type_name" :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">套餐名称</el-col>
          <el-col :span="10">
            <el-input placeholder="请输入套餐名称" :size="inputSize" v-model="saveDataMeal.combo_name" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">套餐价格</el-col>
          <el-col :span="10">
            <el-input placeholder="请输入套餐价格" :size="inputSize" v-model="saveDataMeal.combo_price" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">套餐提成</el-col>
          <el-col :span="10">
            <el-input placeholder="请输入套餐提成" :size="inputSize" v-model="saveDataMeal.combo_royalty" clearable>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">是否含注册：</el-col>
          <el-col :span="10" class="m-label">
            <el-switch v-model="SaveSwitchValueMeal" :width="40" @change="SaveSwitchChangeMeal" active-text="">
            </el-switch>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class="m-label">套餐内容</el-col>
          <el-col :span="10">
            <el-input type="textarea" :rows="4" placeholder="请输入套餐内容" :size="inputSize"
              v-model="saveDataMeal.combo_content" clearable>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSaveMeal">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: 'service_manage',
  data () {
    return {

      combtype: [],
      categoryIdOptions: [],
      inputSize: 'small',
      activeName: 'first',
      switchValueMeal: false,
      switchValueItem: false,
      switchValueOrder: false,
      SaveSwitchValueMeal: false,
      SaveSwitchValueItem: false,
      SaveSwitchValueOrder: false,
      optionService: [],
      optionMeal: [],
      optionItem: [],
      optionReg: [],
      optionOrderReg: [],
      optionIndustry: [],
      optionRefund: [],
      optionClientSource: [],
      optionMealNot: [],
      pageOptionService: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionMeal: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionReg: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionOrderReg: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionIndustry: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionRefund: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionClientSource: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      pageOptionMealNot: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      AddDrawerService: false,
      saveDrawerService: false,
      AddDrawerMeal: false,
      saveDrawerMeal: false,
      AddDrawerItem: false,
      saveDrawerItem: false,
      AddDrawerReg: false,
      saveDrawerReg: false,
      AddDrawerOrderReg: false,
      saveDrawerOrderReg: false,
      AddDrawerIndustry: false,
      saveDrawerIndustry: false,
      AddDrawerRefund: false,
      saveDrawerRefund: false,
      AddDrawerClientSource: false,
      saveDrawerClientSource: false,
      AddDrawerMealNot: false,
      saveDrawerMealNot: false,
      direction: 'rtl',
      addDataService: {
        industry_name: '',
        industry_content: ''
      },
      saveDataService: {
        industry_name: '',
        industry_content: '',
        industry_id: null,
        index: null
      },
      addDataMeal: {
        combo_name: '',
        combo_id: '',
        combo_price: '',
        combo_royalty: '',
        combo_content: '',
        combo_include_reg: '',
        type_id: ''
      },
      saveDataMeal: {
        combo_name: '',
        combo_price: '',
        combo_royalty: '',
        combo_content: '',
        combo_include_reg: '',
        combo_id: null,
        type_id: null,
        index: null
      },
      addDataItem: {
        item_name: '',
        item_content: '',
        item_include_reg: 1,
        item_price: null,
        item_royalty: null,
        is_agency: 1,
        is_tax_report: 1,
        is_open_bank: 1,
        is_tax_plate: 1,
        is_accum_open: 1,
        is_secuity_open: 1,
        is_ensure_agent: 1,
        is_ensure_hosting: 1,
        is_address: 1,
        is_industry_change: 1,
        is_tax_change: 1,
        is_bank_change: 1,
        is_secuity_change: 1,
        is_accum_change: 1,
        is_industry_logout: 1,
        is_tax_logout: 1,
        is_bank_logout: 1,
        is_secuity_logout: 1,
        is_accum_logout: 1,
        is_licence_logout: 1,
        type_id: ''
      },
      saveDataItem: {
        item_id: null,
        item_name: '',
        item_content: '',
        item_include_reg: 1,
        item_price: null,
        item_royalty: null,
        index: null,
        is_agency: 1,
        is_tax_report: 1,
        is_open_bank: 1,
        is_tax_plate: 1,
        is_accum_open: 1,
        is_secuity_open: 1,
        is_ensure_agent: 1,
        is_ensure_hosting: 1,
        is_address: 1,
        is_industry_change: 1,
        is_tax_change: 1,
        is_bank_change: 1,
        is_secuity_change: 1,
        is_accum_change: 1,
        is_industry_logout: 1,
        is_tax_logout: 1,
        is_bank_logout: 1,
        is_secuity_logout: 1,
        is_accum_logout: 1,
        is_licence_logout: 1,
        type_id: ''
      },
      addDataReg: {
        reg_type_name: ''
      },
      saveDataReg: {
        reg_type_name: '',
        reg_type_id: null,
        index: null
      },
      addDataOrderReg: {
        order_reg_name: '',
        order_include_reg: 1,
        is_agency: 1,
        is_tax_report: 1,
        is_open_bank: 1,
        is_tax_plate: 1,
        is_accum_open: 1,
        is_secuity_open: 1,
        is_ensure_agent: 1,
        is_ensure_hosting: 1,
        is_address: 1,
        is_industry_change: 1,
        is_tax_change: 1,
        is_bank_change: 1,
        is_secuity_change: 1,
        is_accum_change: 1,
        is_industry_logout: 1,
        is_tax_logout: 1,
        is_bank_logout: 1,
        is_secuity_logout: 1,
        is_accum_logout: 1,
        is_licence_logout: 1
      },
      upDataOrderReg: {
        index: null,
        order_reg_id: null,
        order_reg_name: '',
        order_include_reg: 1,
        is_agency: 1,
        is_tax_report: 1,
        is_open_bank: 1,
        is_tax_plate: 1,
        is_accum_open: 1,
        is_secuity_open: 1,
        is_ensure_agent: 1,
        is_ensure_hosting: 1,
        is_address: 1,
        is_industry_change: 1,
        is_tax_change: 1,
        is_bank_change: 1,
        is_secuity_change: 1,
        is_accum_change: 1,
        is_industry_logout: 1,
        is_tax_logout: 1,
        is_bank_logout: 1,
        is_secuity_logout: 1,
        is_accum_logout: 1,
        is_licence_logout: 1
      },
      addDataIndustry: {
        industry_name: ''
      },
      saveDataIndustry: {
        industry_name: '',
        industry_id: null,
        index: null
      },
      addDataRefund: {
        refund_cause: '',
        refund_id: ''
      },
      saveDataRefund: {
        refund_cause: '',
        refund_id: null,
        index: null
      },
      addDataClientSource: {
        source_id: '',
        source_name: ''
      },
      saveDataClientSource: {
        source_id: '',
        source_name: '',
        index: null
      },
      addDataMealNot: {
        not_id: '',
        not_name: ''
      },
      saveDataMealNot: {
        not_id: '',
        not_name: '',
        index: null
      }
    }
  },
  computed: {
    pageDataService: {
      get: function () {
        return this.optionService.slice(this.pageOptionService.pageSize * (this.pageOptionService.currentPage - 1), this.pageOptionService.pageSize * this.pageOptionService.currentPage)
      }
    },
    pageDataMeal: {
      get: function () {
        return this.optionMeal.slice(this.pageOptionMeal.pageSize * (this.pageOptionMeal.currentPage - 1), this.pageOptionMeal.pageSize * this.pageOptionMeal.currentPage)
      }
    },
    pageDataItem: {
      get: function () {
        return this.optionItem.slice(this.pageOptionItem.pageSize * (this.pageOptionItem.currentPage - 1), this.pageOptionItem.pageSize * this.pageOptionItem.currentPage)
      }
    },
    pageDataReg: {
      get: function () {
        return this.optionReg.slice(this.pageOptionReg.pageSize * (this.pageOptionReg.currentPage - 1), this.pageOptionReg.pageSize * this.pageOptionReg.currentPage)
      }
    },
    pageDataOrderReg: {
      get: function () {
        return this.optionOrderReg.slice(this.pageOptionOrderReg.pageSize * (this.pageOptionOrderReg.currentPage - 1), this.pageOptionOrderReg.pageSize * this.pageOptionOrderReg.currentPage)
      }
    },
    pageDataIndustry: {
      get: function () {
        return this.optionIndustry.slice(this.pageOptionIndustry.pageSize * (this.pageOptionIndustry.currentPage - 1), this.pageOptionIndustry.pageSize * this.pageOptionIndustry.currentPage)
      }
    },
    pageDataRefund: {
      get: function () {
        return this.optionRefund.slice(this.pageOptionRefund.pageSize * (this.pageOptionRefund.currentPage - 1), this.pageOptionRefund.pageSize * this.pageOptionRefund.currentPage)
      }
    },
    pageDataClientSource: {
      get: function () {
        return this.optionClientSource.slice(this.pageOptionClientSource.pageSize * (this.pageOptionClientSource.currentPage - 1), this.pageOptionClientSource.pageSize * this.pageOptionClientSource.currentPage)
      }
    },
    pageDataMealNot: {
      get: function () {
        return this.optionMealNot.slice(this.pageOptionMealNot.pageSize * (this.pageOptionMealNot.currentPage - 1), this.pageOptionMealNot.pageSize * this.pageOptionMealNot.currentPage)
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    loadCategory () {
      this.$axios
        .get('api/product_type/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryIdOptions = data.data
          }
        })
        .catch()
    },
    combloadCategory () {
      this.$axios
        .get('api/product_type/combgetcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.combtype = data.data
          }
        })
        .catch()
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    // 服务名称
    getDataService () {
      this.$axios.get('/api/servertype/list')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionService = data.data
            this.pageOptionService.total = this.optionService.length
          }
        })
    },
    handleAddOpenService () {
      this.AddDrawerService = true
    },
    handleAddService () {
      if (!this.addDataService.industry_name) {
        this.$message.error('服务名称不能为空')
        return
      }
      if (!this.addDataService.industry_name) {
        this.$message.error('服务内容不能为空')
        return
      }
      this.$axios.post('/api/servertype/create', { val: [this.addDataService.industry_name, this.addDataService.industry_content] })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionService.unshift(data.data)
            this.pageOptionService.total = this.optionService.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerService = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditService (index, row) {
      this.saveDataService.industry_name = row.server_name
      this.saveDataService.industry_id = row.server_id
      this.saveDataService.industry_content = row.server_content
      this.saveDataService.index = index
      this.saveDrawerService = true
    },
    handleSaveService () {
      if (!this.saveDataService.industry_name) {
        this.$message.error('服务名称不能为空')
        return
      }
      if (!this.saveDataService.industry_content) {
        this.$message.error('服务内容不能为空')
        return
      }
      this.$axios.get('/api/servertype/update/' + this.saveDataService.industry_id, {
        params: {
          val: [this.saveDataService.industry_name, this.saveDataService.industry_content]
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let index = this.pageOptionService.pageSize * (this.pageOptionService.currentPage - 1) + this.saveDataService.index
            this.optionService[index].server_name = this.saveDataService.industry_name
            this.optionService[index].server_content = this.saveDataService.industry_content
            this.$message.success(data.msg)
            this.clearSaveData()
            this.saveDrawerService = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleDeleteService (index, id) {
      this.handleDeleteSubService(index, id)
    },
    handleDeleteSubService (index, id) {
      this.$axios.get('/api/servertype/delete/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionService.pageSize * (this.pageOptionService.currentPage - 1) + index
            this.optionService.splice(idx, 1)
            this.pageOptionService.total = this.optionService.length
            if (index === 0) this.prePage(this.pageOptionService, 'service')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeService (val) {
      this.pageOptionService.pageSize = val
    },
    handleCurrentChangeService (val) {
      this.pageOptionService.currentPage = val
    },
    // 实际注册类型
    getDataReg () {
      this.$axios.get('/api/companytype/get')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionReg = data.data
            this.pageOptionReg.total = this.optionReg.length
          }
        })
    },
    handleAddOpenReg () {
      this.AddDrawerReg = true
    },
    handleAddReg () {
      if (!this.addDataReg.reg_type_name) {
        this.$message.error('注册类型不能为空')
        return
      }
      this.$axios.get('/api/companytype/create?reg_type_name=' + this.addDataReg.reg_type_name)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionReg.unshift(data.data)
            this.pageOptionReg.total = this.optionReg.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerReg = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditReg (index, row) {
      this.saveDataReg.reg_type_name = row.reg_type_name
      this.saveDataReg.reg_type_id = row.reg_type_id
      this.saveDataReg.index = index
      this.saveDrawerReg = true
    },
    handleSaveReg () {
      if (!this.saveDataReg.reg_type_name) {
        this.$message.error('注册类型不能为空')
        return
      }
      this.$axios.get('/api/companytype/update?reg_type_name=' + this.saveDataReg.reg_type_name + '&reg_type_id=' + this.saveDataReg.reg_type_id).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionReg.pageSize * (this.pageOptionReg.currentPage - 1) + this.saveDataReg.index
          this.optionReg[index].reg_type_name = this.saveDataReg.reg_type_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerReg = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleDeleteReg (index, id) {
      this.handleDeleteSubReg(index, id)
    },
    handleDeleteSubReg (index, id) {
      this.$axios.get('/api/companytype/delete?reg_type_id=' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionReg.pageSize * (this.pageOptionReg.currentPage - 1) + index
            this.optionReg.splice(idx, 1)
            this.pageOptionReg.total = this.optionReg.length
            if (index === 0) this.prePage(this.pageOptionReg, 'reg')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeReg (val) {
      this.pageOptionReg.pageSize = val
    },
    handleCurrentChangeReg (val) {
      this.pageOptionReg.currentPage = val
    },
    // 订单类型
    getDataOrderReg () {
      this.$axios.get('/api/order_reg/reg_type_list')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionOrderReg = data.data
            this.pageOptionOrderReg.total = this.optionOrderReg.length
          }
        })
    },
    handleAddOpenOrderReg () {
      this.clearOrderRegData()
      this.AddDrawerOrderReg = true
    },
    handleAddOrderReg () {
      if (!this.addDataOrderReg.order_reg_name) {
        this.$message.error('订单类型不能为空')
        return
      }
      this.$axios.post('/api/order_reg/create', this.addDataOrderReg)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionOrderReg.unshift(data.data)
            this.pageOptionOrderReg.total = this.optionOrderReg.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerOrderReg = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditOrderReg (index, row) {
      this.upDataOrderReg.index = index
      this.upDataOrderReg.order_reg_id = row.order_reg_id
      this.upDataOrderReg.order_reg_name = row.order_reg_name
      this.upDataOrderReg.order_include_reg = row.order_include_reg
      this.upDataOrderReg.is_agency = row.is_agency
      this.upDataOrderReg.is_tax_report = row.is_tax_report
      this.upDataOrderReg.is_open_bank = row.is_open_bank
      this.upDataOrderReg.is_tax_plate = row.is_tax_plate
      this.upDataOrderReg.is_accum_open = row.is_accum_open
      this.upDataOrderReg.is_secuity_open = row.is_secuity_open
      this.upDataOrderReg.is_ensure_agent = row.is_ensure_agent
      this.upDataOrderReg.is_ensure_hosting = row.is_ensure_hosting
      this.upDataOrderReg.is_address = row.is_address
      this.upDataOrderReg.is_industry_change = row.is_industry_change
      this.upDataOrderReg.is_tax_change = row.is_tax_change
      this.upDataOrderReg.is_bank_change = row.is_bank_change
      this.upDataOrderReg.is_secuity_change = row.is_secuity_change
      this.upDataOrderReg.is_accum_change = row.is_accum_change
      this.upDataOrderReg.is_industry_logout = row.is_industry_logout
      this.upDataOrderReg.is_tax_logout = row.is_tax_logout
      this.upDataOrderReg.is_bank_logout = row.is_bank_logout
      this.upDataOrderReg.is_secuity_logout = row.is_secuity_logout
      this.upDataOrderReg.is_accum_logout = row.is_accum_logout
      this.upDataOrderReg.is_licence_logout = row.is_licence_logout
      this.saveDrawerOrderReg = true
    },
    clearOrderRegData () {
      this.addDataOrderReg.index = null
      this.addDataOrderReg.order_reg_id = null
      this.addDataOrderReg.order_reg_name = ''
      this.addDataOrderReg.order_include_reg = 1
      this.addDataOrderReg.is_agency = 1
      this.addDataOrderReg.is_tax_report = 1
      this.addDataOrderReg.is_open_bank = 1
      this.addDataOrderReg.is_tax_plate = 1
      this.addDataOrderReg.is_accum_open = 1
      this.addDataOrderReg.is_secuity_open = 1
      this.addDataOrderReg.is_ensure_agent = 1
      this.addDataOrderReg.is_ensure_hosting = 1
      this.addDataOrderReg.is_address = 1
      this.addDataOrderReg.is_industry_change = 1
      this.addDataOrderReg.is_tax_change = 1
      this.addDataOrderReg.is_bank_change = 1
      this.addDataOrderReg.is_secuity_change = 1
      this.addDataOrderReg.is_accum_change = 1
      this.addDataOrderReg.is_industry_logout = 1
      this.addDataOrderReg.is_tax_logout = 1
      this.addDataOrderReg.is_bank_logout = 1
      this.addDataOrderReg.is_secuity_logout = 1
      this.addDataOrderReg.is_accum_logout = 1
      this.addDataOrderReg.is_licence_logout = 1
    },
    handleSaveOrderReg () {
      if (!this.upDataOrderReg.order_reg_name) {
        this.$message.error('订单类型不能为空')
        return
      }
      this.$axios.post('/api/order_reg/update/' + this.upDataOrderReg.order_reg_id, this.upDataOrderReg)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let index = this.pageOptionOrderReg.pageSize * (this.pageOptionOrderReg.currentPage - 1) + this.upDataOrderReg.index
            this.optionOrderReg[index].order_reg_name = this.upDataOrderReg.order_reg_name
            this.optionOrderReg[index].order_include_reg = this.upDataOrderReg.order_include_reg
            this.optionOrderReg[index].is_agency = this.upDataOrderReg.is_agency
            this.optionOrderReg[index].is_tax_report = this.upDataOrderReg.is_tax_report
            this.optionOrderReg[index].is_open_bank = this.upDataOrderReg.is_open_bank
            this.optionOrderReg[index].is_tax_plate = this.upDataOrderReg.is_tax_plate
            this.optionOrderReg[index].is_accum_open = this.upDataOrderReg.is_accum_open
            this.optionOrderReg[index].is_secuity_open = this.upDataOrderReg.is_secuity_open
            this.optionOrderReg[index].is_ensure_agent = this.upDataOrderReg.is_ensure_agent
            this.optionOrderReg[index].is_ensure_hosting = this.upDataOrderReg.is_ensure_hosting
            this.optionOrderReg[index].is_address = this.upDataOrderReg.is_address
            this.optionOrderReg[index].is_industry_change = this.upDataOrderReg.is_industry_change
            this.optionOrderReg[index].is_tax_change = this.upDataOrderReg.is_tax_change
            this.optionOrderReg[index].is_bank_change = this.upDataOrderReg.is_bank_change
            this.optionOrderReg[index].is_secuity_change = this.upDataOrderReg.is_secuity_change
            this.optionOrderReg[index].is_accum_change = this.upDataOrderReg.is_accum_change
            this.optionOrderReg[index].is_industry_logout = this.upDataOrderReg.is_industry_logout
            this.optionOrderReg[index].is_tax_logout = this.upDataOrderReg.is_tax_logout
            this.optionOrderReg[index].is_bank_logout = this.upDataOrderReg.is_bank_logout
            this.optionOrderReg[index].is_secuity_logout = this.upDataOrderReg.is_secuity_logout
            this.optionOrderReg[index].is_accum_logout = this.upDataOrderReg.is_accum_logout
            this.optionOrderReg[index].is_licence_logout = this.upDataOrderReg.is_licence_logout
            this.$message.success(data.msg)
            this.clearSaveData()
            this.saveDrawerOrderReg = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleDeleteOrderReg (index, id) {
      this.handleDeleteSubOrderReg(index, id)
    },
    handleDeleteSubOrderReg (index, id) {
      this.$axios.get('/api/order_reg/delete/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionOrderReg.pageSize * (this.pageOptionOrderReg.currentPage - 1) + index
            this.optionOrderReg.splice(idx, 1)
            this.pageOptionOrderReg.total = this.optionOrderReg.length
            if (index === 0) this.prePage(this.pageOptionOrderReg, 'OrderReg')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeOrderReg (val) {
      this.pageOptionOrderReg.pageSize = val
    },
    handleCurrentChangeOrderReg (val) {
      this.pageOptionOrderReg.currentPage = val
    },
    // 套餐类型
    getDataMeal () {
      this.$axios.get('/api/combo/list')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionMeal = data.data
            this.pageOptionMeal.total = this.optionMeal.length
          }
        })
    },
    switchChangeMeal (value) {
      this.addDataMeal.combo_include_reg = value ? 2 : 1
    },
    SaveSwitchChangeMeal (value) {
      this.saveDataMeal.combo_include_reg = value ? 2 : 1
    },
    handleAddOpenMeal () {
      this.AddDrawerMeal = true
    },
    handleAddMeal () {
      if (!this.addDataMeal.type_id) {
        this.$message.error('请选着产品类型')
        return
      }
      if (!this.addDataMeal.combo_name) {
        this.$message.error('套餐名称不能为空')
        return
      }
      if (!this.addDataMeal.combo_price) {
        this.$message.error('套餐价格不能为空')
        return
      }
      if (!this.addDataMeal.combo_royalty) {
        this.$message.error('套餐提成不能为空')
        return
      }
      if (!this.addDataMeal.combo_content) {
        this.$message.error('套餐内容不能为空')
        return
      }
      this.$axios.get('/api/combo/create', {
        params: {
          combo_name: this.addDataMeal.combo_name,
          combo_price: this.addDataMeal.combo_price,
          combo_royalty: this.addDataMeal.combo_royalty,
          combo_content: this.addDataMeal.combo_content,
          combo_include_reg: this.addDataMeal.combo_include_reg,
          type_id: this.addDataMeal.type_id
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            // this.optionMeal.unshift(data.data)
            this.getDataMeal()
            this.pageOptionMeal.total = this.optionMeal.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerMeal = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditMeal (index, row) {
      this.saveDataMeal.combo_name = row.combo_name
      this.saveDataMeal.combo_id = row.combo_id
      this.saveDataMeal.combo_price = row.combo_price
      this.saveDataMeal.combo_royalty = row.combo_royalty
      this.saveDataMeal.combo_content = row.combo_content
      this.saveDataMeal.type_id = row.type_id
      let status = false
      this.SaveSwitchValueMeal = row.combo_include_reg === 2 ? true : status
      this.saveDataMeal.combo_include_reg = this.SaveSwitchValueMeal
      this.saveDataMeal.index = index
      this.saveDrawerMeal = true
    },
    handleSaveMeal () {
      if (!this.saveDataMeal.combo_name) {
        this.$message.error('套餐名称不能为空')
        return
      }
      this.$axios.get('/api/combo/update/' + this.saveDataMeal.combo_id, {
        params: {
          combo_name: this.saveDataMeal.combo_name,
          combo_price: this.saveDataMeal.combo_price,
          combo_royalty: this.saveDataMeal.combo_royalty,
          combo_content: this.saveDataMeal.combo_content,
          combo_include_reg: this.saveDataMeal.combo_include_reg,
          type_id: this.saveDataMeal.type_id
        }
      }).then((res) => {
        const { data } = res
        if (data.code === 0) {
          this.getDataMeal()
          // let index = this.pageOptionMeal.pageSize * (this.pageOptionMeal.currentPage - 1) + this.saveDataMeal.index
          // this.optionMeal[index].combo_name = this.saveDataMeal.combo_name
          // this.optionMeal[index].combo_price = this.saveDataMeal.combo_price
          // this.optionMeal[index].combo_royalty = this.saveDataMeal.combo_royalty
          // this.optionMeal[index].combo_content = this.saveDataMeal.combo_content
          // this.optionMeal[index].combo_include_reg = this.saveDataMeal.combo_include_reg
          // this.optionMeal[index].type_id = this.saveDataMeal.type_id
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerMeal = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleDeleteMeal (index, id) {
      this.handleDeleteSubMeal(index, id)
    },
    handleDeleteSubMeal (index, id) {
      this.$axios.get('/api/combo/delete/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionMeal.pageSize * (this.pageOptionMeal.currentPage - 1) + index
            this.optionMeal.splice(idx, 1)
            this.pageOptionMeal.total = this.optionMeal.length
            if (index === 0) this.prePage(this.pageOptionMeal, 'meal')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeMeal (val) {
      this.pageOptionMeal.pageSize = val
    },
    handleCurrentChangeMeal (val) {
      this.pageOptionMeal.currentPage = val
    },
    // 单品类型
    getDataItem () {
      this.$axios.get('/api/itemtype/list')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionItem = data.data
            this.pageOptionItem.total = this.optionItem.length
          }
        })
    },
    handleAddOpenItem () {
      this.AddDrawerItem = true
    },
    handleAddItem () {
      if (!this.addDataItem.type_id) {
        this.$message.error('请选择产品类型')
        return
      }
      if (!this.addDataItem.item_name) {
        this.$message.error('单品名称不能为空')
        return
      }
      if (!this.addDataItem.item_name) {
        this.$message.error('单品内容不能为空')
        return
      }
      this.$axios.post('/api/itemtype/create', this.addDataItem)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.getDataItem()
            this.pageOptionItem.total = this.optionItem.length
            this.$message.success(data.msg)
            this.clearAddItemData()
            this.AddDrawerItem = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    clearAddItemData () {
      this.addDataItem.is_accum_change = 1
      this.addDataItem.is_accum_logout = 1
      this.addDataItem.is_accum_open = 1
      this.addDataItem.is_address = 1
      this.addDataItem.is_agency = 1
      this.addDataItem.is_bank_change = 1
      this.addDataItem.is_bank_logout = 1
      this.addDataItem.is_ensure_agent = 1
      this.addDataItem.is_ensure_hosting = 1
      this.addDataItem.is_industry_change = 1
      this.addDataItem.is_industry_logout = 1
      this.addDataItem.is_licence_logout = 1
      this.addDataItem.is_open_bank = 1
      this.addDataItem.is_secuity_change = 1
      this.addDataItem.is_secuity_logout = 1
      this.addDataItem.is_secuity_open = 1
      this.addDataItem.is_tax_change = 1
      this.addDataItem.is_tax_logout = 1
      this.addDataItem.is_tax_plate = 1
      this.addDataItem.is_tax_report = 1
      this.addDataItem.item_content = ''
      this.addDataItem.item_include_reg = 1
      this.addDataItem.item_name = ''
      this.addDataItem.item_price = ''
      this.addDataItem.item_royalty = ''
    },
    handleEditItem (index, row) {
      this.saveDataItem.is_accum_change = row.is_accum_change
      this.saveDataItem.is_accum_logout = row.is_accum_logout
      this.saveDataItem.is_accum_open = row.is_accum_open
      this.saveDataItem.is_address = row.is_address
      this.saveDataItem.is_agency = row.is_agency
      this.saveDataItem.is_bank_change = row.is_bank_change
      this.saveDataItem.is_bank_logout = row.is_bank_logout
      this.saveDataItem.is_ensure_agent = row.is_ensure_agent
      this.saveDataItem.is_ensure_hosting = row.is_ensure_hosting
      this.saveDataItem.is_industry_change = row.is_industry_change
      this.saveDataItem.is_industry_logout = row.is_industry_logout
      this.saveDataItem.is_licence_logout = row.is_licence_logout
      this.saveDataItem.is_open_bank = row.is_open_bank
      this.saveDataItem.is_secuity_change = row.is_secuity_change
      this.saveDataItem.is_secuity_logout = row.is_secuity_logout
      this.saveDataItem.is_secuity_open = row.is_secuity_open
      this.saveDataItem.is_tax_change = row.is_tax_change
      this.saveDataItem.is_tax_logout = row.is_tax_logout
      this.saveDataItem.is_tax_plate = row.is_tax_plate
      this.saveDataItem.is_tax_report = row.is_tax_report
      this.saveDataItem.item_content = row.item_content
      this.saveDataItem.item_include_reg = row.item_include_reg
      this.saveDataItem.item_name = row.item_name
      this.saveDataItem.item_price = row.item_price
      this.saveDataItem.item_royalty = row.item_royalty
      this.saveDataItem.item_id = row.item_id
      this.saveDataItem.index = index
      this.saveDataItem.type_id = row.type_id
      this.saveDrawerItem = true
    },
    handleSaveItem () {
      if (!this.saveDataItem.item_name) {
        this.$message.error('单品名称不能为空')
        return
      }
      if (!this.saveDataItem.item_content) {
        this.$message.error('单品内容不能为空')
        return
      }
      this.$axios.post('/api/itemtype/update/' + this.saveDataItem.item_id, this.saveDataItem)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.getDataItem()
            this.$message.success(data.msg)
            this.clearSaveItemData()
            this.saveDrawerItem = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    clearSaveItemData () {
      this.saveDataItem.is_accum_change = 1
      this.saveDataItem.is_accum_logout = 1
      this.saveDataItem.is_accum_open = 1
      this.saveDataItem.is_address = 1
      this.saveDataItem.is_agency = 1
      this.saveDataItem.is_bank_change = 1
      this.saveDataItem.is_bank_logout = 1
      this.saveDataItem.is_ensure_agent = 1
      this.saveDataItem.is_ensure_hosting = 1
      this.saveDataItem.is_industry_change = 1
      this.saveDataItem.is_industry_logout = 1
      this.saveDataItem.is_licence_logout = 1
      this.saveDataItem.is_open_bank = 1
      this.saveDataItem.is_secuity_change = 1
      this.saveDataItem.is_secuity_logout = 1
      this.saveDataItem.is_secuity_open = 1
      this.saveDataItem.is_tax_change = 1
      this.saveDataItem.is_tax_logout = 1
      this.saveDataItem.is_tax_plate = 1
      this.saveDataItem.is_tax_report = 1
      this.saveDataItem.item_content = ''
      this.saveDataItem.item_include_reg = 1
      this.saveDataItem.item_name = ''
      this.saveDataItem.item_price = ''
      this.saveDataItem.item_royalty = ''
    },
    handleDeleteItem (index, id) {
      this.handleDeleteSubItem(index, id)
    },
    handleDeleteSubItem (index, id) {
      this.$axios.get('/api/itemtype/delete/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionItem.pageSize * (this.pageOptionItem.currentPage - 1) + index
            this.optionItem.splice(idx, 1)
            this.pageOptionItem.total = this.optionItem.length
            if (index === 0) this.prePage(this.pageOptionItem, 'item')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeItem (val) {
      this.pageOptionItem.pageSize = val
    },
    handleCurrentChangeItem (val) {
      this.pageOptionItem.currentPage = val
    },
    // 行业管理
    getDataIndustry () {
      this.$axios.get('/api/industry/get')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionIndustry = data.data
            this.pageOptionIndustry.total = this.optionIndustry.length
          }
        })
    },
    handleAddOpenIndustry () {
      this.AddDrawerIndustry = true
    },
    handleAddIndustry () {
      if (!this.addDataIndustry.industry_name) {
        this.$message.error('行业名称不能为空')
        return
      }
      this.$axios.get('/api/industry/create?industry_name=' + this.addDataIndustry.industry_name)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionIndustry.unshift(data.data)
            this.pageOptionIndustry.total = this.optionIndustry.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerIndustry = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditIndustry (index, row) {
      this.saveDataIndustry.industry_name = row.industry_name
      this.saveDataIndustry.industry_id = row.industry_id
      this.saveDataIndustry.index = index
      this.saveDrawerIndustry = true
    },
    handleSaveIndustry () {
      if (!this.saveDataIndustry.industry_name) {
        this.$message.error('行业不能为空')
        return
      }
      this.$axios.get('/api/industry/update?industry_name=' + this.saveDataIndustry.industry_name + '&industry_id=' + this.saveDataIndustry.industry_id).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionIndustry.pageSize * (this.pageOptionIndustry.currentPage - 1) + this.saveDataIndustry.index
          this.optionIndustry[index].industry_name = this.saveDataIndustry.industry_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerIndustry = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleDeleteIndustry (index, id) {
      this.handleDeleteSubIndustry(index, id)
    },
    handleDeleteSubIndustry (index, id) {
      this.$axios.get('/api/industry/delete?industry_id=' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionIndustry.pageSize * (this.pageOptionIndustry.currentPage - 1) + index
            this.optionIndustry.splice(idx, 1)
            this.pageOptionIndustry.total = this.optionIndustry.length
            if (index === 0) this.prePage(this.pageOptionIndustry, 'industry')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeIndustry (val) {
      this.pageOptionIndustry.pageSize = val
    },
    handleCurrentChangeIndustry (val) {
      this.pageOptionIndustry.currentPage = val
    },
    // 退款原因
    getDataRefund () {
      this.$axios.get('/api/refundcause/list')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionRefund = data.data
            this.pageOptionRefund.total = this.optionRefund.length
          }
        })
    },
    handleAddOpenRefund () {
      this.AddDrawerRefund = true
    },
    handleAddRefund () {
      if (!this.addDataRefund.refund_cause) {
        this.$message.error('退款原因不能为空')
        return
      }
      this.$axios.get('/api/refundcause/create', {
        params: {
          refund_cause: this.addDataRefund.refund_cause
        }
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionRefund.unshift(data.data)
            this.pageOptionRefund.total = this.optionRefund.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerRefund = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditRefund (index, row) {
      this.saveDataRefund.refund_cause = row.refund_cause
      this.saveDataRefund.refund_id = row.refund_id
      this.saveDataRefund.index = index
      this.saveDrawerRefund = true
    },
    handleSaveRefund () {
      if (!this.saveDataRefund.refund_cause) {
        this.$message.error('退款原因不能为空')
        return
      }
      this.$axios.get('/api/refundcause/update/' + this.saveDataRefund.refund_id, {
        params: {
          refund_cause: this.saveDataRefund.refund_cause
        }
      }).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionRefund.pageSize * (this.pageOptionRefund.currentPage - 1) + this.saveDataRefund.index
          this.optionRefund[index].refund_cause = this.saveDataRefund.refund_cause
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerRefund = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleDeleteRefund (index, id) {
      this.handleDeleteSubRefund(index, id)
    },
    handleDeleteSubRefund (index, id) {
      this.$axios.get('/api/refundcause/delete/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionRefund.pageSize * (this.pageOptionRefund.currentPage - 1) + index
            this.optionRefund.splice(idx, 1)
            this.pageOptionRefund.total = this.optionRefund.length
            if (index === 0) this.prePage(this.pageOptionRefund, 'refund')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeRefund (val) {
      this.pageOptionRefund.pageSize = val
    },
    handleCurrentChangeRefund (val) {
      this.pageOptionRefund.currentPage = val
    },
    // 客户来源
    getDataClientSource () {
      this.$axios.get('/api/custom_source/list')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionClientSource = data.data
            this.pageOptionClientSource.total = this.optionClientSource.length
          }
        })
    },
    handleAddOpenClientSource () {
      this.AddDrawerClientSource = true
    },
    handleAddClientSource () {
      if (!this.addDataClientSource.source_name) {
        this.$message.error('客户来源不能为空')
        return
      }
      this.$axios.post('/api/custom_source/create', { source_name: this.addDataClientSource.source_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionClientSource.unshift(data.data)
            this.pageOptionClientSource.total = this.optionClientSource.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerClientSource = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditClientSource (index, row) {
      this.saveDataClientSource.source_name = row.source_name
      this.saveDataClientSource.source_id = row.source_id
      this.saveDataClientSource.index = index
      this.saveDrawerClientSource = true
    },
    handleSaveClientSource () {
      if (!this.saveDataClientSource.source_name) {
        this.$message.error('客户来源不能为空')
        return
      }
      this.$axios.get('/api/custom_source/update/' + this.saveDataClientSource.source_id, {
        params: {
          source_name: this.saveDataClientSource.source_name
        }
      }).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionClientSource.pageSize * (this.pageOptionClientSource.currentPage - 1) + this.saveDataClientSource.index
          this.optionClientSource[index].source_name = this.saveDataClientSource.source_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerClientSource = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleDeleteClientSource (index, id) {
      this.handleDeleteSubClientSource(index, id)
    },
    handleDeleteSubClientSource (index, id) {
      this.$axios.get('/api/custom_source/delete/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionClientSource.pageSize * (this.pageOptionClientSource.currentPage - 1) + index
            this.optionClientSource.splice(idx, 1)
            this.pageOptionClientSource.total = this.optionClientSource.length
            if (index === 0) this.prePage(this.pageOptionClientSource, 'ClientSource')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeClientSource (val) {
      this.pageOptionClientSource.pageSize = val
    },
    handleCurrentChangeClientSource (val) {
      this.pageOptionClientSource.currentPage = val
    },
    // 套餐不需要的原因
    getDataMealNot () {
      this.$axios.get('/api/not_need_cause/list')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionMealNot = data.data
            this.pageOptionMealNot.total = this.optionMealNot.length
          }
        })
    },
    handleAddOpenMealNot () {
      this.AddDrawerMealNot = true
    },
    handleAddMealNot () {
      if (!this.addDataMealNot.not_name) {
        this.$message.error('原因不能为空')
        return
      }
      this.$axios.post('/api/not_need_cause/create', { not_name: this.addDataMealNot.not_name })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.optionMealNot.unshift(data.data)
            this.pageOptionMealNot.total = this.optionMealNot.length
            this.$message.success(data.msg)
            this.clearAddData()
            this.AddDrawerMealNot = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleEditMealNot (index, row) {
      this.saveDataMealNot.not_name = row.not_name
      this.saveDataMealNot.not_id = row.not_id
      this.saveDataMealNot.index = index
      this.saveDrawerMealNot = true
    },
    handleSaveMealNot () {
      if (!this.saveDataMealNot.not_name) {
        this.$message.error('原因不能为空')
        return
      }
      this.$axios.get('/api/not_need_cause/update/' + this.saveDataMealNot.not_id, {
        params: {
          not_name: this.saveDataMealNot.not_name
        }
      }).then((res) => {
        const { data } = res
        if (data.code === 0) {
          let index = this.pageOptionMealNot.pageSize * (this.pageOptionMealNot.currentPage - 1) + this.saveDataMealNot.index
          this.optionMealNot[index].not_name = this.saveDataMealNot.not_name
          this.$message.success(data.msg)
          this.clearSaveData()
          this.saveDrawerMealNot = false
        } else {
          this.$message.error(data.msg)
        }
      })
    },
    handleDeleteMealNot (index, id) {
      this.handleDeleteSubMealNot(index, id)
    },
    handleDeleteSubMealNot (index, id) {
      this.$axios.get('/api/not_need_cause/delete/' + id)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let idx = this.pageOptionMealNot.pageSize * (this.pageOptionMealNot.currentPage - 1) + index
            this.optionMealNot.splice(idx, 1)
            this.pageOptionMealNot.total = this.optionMealNot.length
            if (index === 0) this.prePage(this.pageOptionMealNot, 'MealNot')
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleSizeChangeMealNot (val) {
      this.pageOptionMealNot.pageSize = val
    },
    handleCurrentChangeMealNot (val) {
      this.pageOptionMealNot.currentPage = val
    },
    handleSaveDrawerClose (done) {
      this.$confirm('确认关闭?')
        .then(_ => {
          this.clearSaveData()
          done()
        })
        .catch(_ => {
        })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    clearSaveData () {
      this.addDataService.industry_name = ''
      this.addDataService.industry_content = ''
    },
    setSort (row) {
      if (isNaN(row.sort - 0)) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios.put('api/itemtype/setsort', {
        item_id: row.item_id,
        sort: row.sort
      })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.clearSaveData()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    }
  },
  mounted () {
    // this.getDataService()
    this.getDataMeal()
    // this.getDataReg()
    // this.getDataOrderReg()
    // this.getDataItem()
    // this.getDataIndustry()
    // this.getDataRefund()
    // this.getDataClientSource()
    // this.getDataMealNot()
    this.loadCategory()
    this.combloadCategory()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span
    color: #4c87fc
    font-size 0.36rem
    font-weight 400
  .service_manage
    marginLeft()
  .mt-10
    margin-top: .2rem
  .tr
    text-align: right
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    overflow-y auto
    .m-label
      line-height: .64rem
    .el-row
      margin-bottom: .4rem
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width: 100%
    .el-select
      width: 100%
  .service_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  .addCon
    padding: .2rem
    text-align: right
  .count_style
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/TctypeList.vue